import React from 'react';
import { translate } from 'utlis/translations/i18n';

class SequencePagination extends React.Component {
    render() {
        const { sessionInstance, session, className = '' } = this.props;
        const { currentSequence } = sessionInstance;
        const { data } = session;
        const { sequences = [] } = data;

        return (
            <div className={"sequence-pagination-wrapper " + className}>
                <div className="pagination">
                    <span className={"muted" + className}>{translate('sequence')}</span> {currentSequence + 1} <span className={"muted" + className}>{translate('of')}</span> {sequences.length}
                </div>
            </div>
        );
    }
}
export default SequencePagination;